import { render, staticRenderFns } from "./skillsection.vue?vue&type=template&id=047e423b&scoped=true&"
import script from "./skillsection.vue?vue&type=script&lang=js&"
export * from "./skillsection.vue?vue&type=script&lang=js&"
import style0 from "./skillsection.vue?vue&type=style&index=0&id=047e423b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047e423b",
  null
  
)

export default component.exports